import { Button, Container, Heading, Spacer, Stack } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { routes } from '../data/routes';
import Emoji from './Emoji';
import { Fade } from './Fade';

export const NotFound = () => (
  <Fade>
    <Container>
      <Stack spacing={4}>
        <Heading fontSize={['4xl', '6xl']}>
          <Emoji symbol="🕵️‍♀️" /> Hmm.
        </Heading>
        <Heading fontSize="2xl">
          We couldn{"'"}t seem to find the thing you{"'"}re looking for.
        </Heading>
        <Spacer />
        <Spacer />
        <Link to={routes.root}>
          <Button>
            <Emoji symbol="🏡" label="Emoji of a house" spaceRight /> Go Home
          </Button>
        </Link>
      </Stack>
    </Container>
  </Fade>
);
